import { render, staticRenderFns } from "./WarehouseInventory.vue?vue&type=template&id=cf99ea3a"
import script from "./WarehouseInventory.vue?vue&type=script&lang=js"
export * from "./WarehouseInventory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports